import axiosInstance from '../api/axiosInstance';
import { buildWorkspaceDashboardPath } from './workspaceRouteUtils';

export const isUserAuthenticated = () => localStorage.getItem('isAuthenticated') === 'true';

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch (error) {
    return {};
  }
};

// Users who already finished onboarding re-enter the wizard at Step 2 (no intent selection / auth)
export const isWizardCompletedUser = () => {
  const user = getStoredUser();
  return isUserAuthenticated() && Boolean(user.accessToken) && user.is_wizard_completed === true;
};

export const fetchLastWorkspaceDashboardTarget = async () => {
  const workspaceResponse = await axiosInstance.get('/workspace/list_workspaces');
  const lastWorkspace = workspaceResponse?.last_workspace_data;
  const lastProject = workspaceResponse?.last_project_data;

  if (lastWorkspace?.id && lastProject?.project_id) {
    return {
      path: buildWorkspaceDashboardPath(lastWorkspace.id, lastProject.project_id),
      lastWorkspace,
      lastProject,
    };
  }

  return { path: '/dashboard', lastWorkspace: null, lastProject: null };
};
